'use strict';

/* eslint-disable no-unused-vars */
define([], function () {

  var stickyOptanonCookieButton = function stickyOptanonCookieButton() {

    var component = {};

    var _config = {
      selectors: {
        optinButton: '.accept-cookies-button',
        optinComponent: '.optanon-alert-box-wrapper'
      },
      cookie: {
        isSet: false,
        name: 'OptanonAlertBoxClosed'
      },
      tick: {
        end: 30,
        tick: 0,
        interval: 1000
      },
      domElements: {
        optinButton: null
      }

    };

    var _init = function _init(element) {

      component.element = element;

      if (document.cookie !== undefined && component.cookieCheck() !== false) {
        component.showComponent();
      } else {
        component.intervalCheck(component.bindEventListeners);
      }
    };

    var _intervalCheck = function _intervalCheck(callBack) {

      var _intervalFunction = void 0;

      setTimeout(_intervalFunction = function intervalFunction() {

        clearTimeout(_intervalFunction);

        component.config.domElements.optinButton = document.querySelector(component.config.selectors.optinButton);
        component.config.tick.tick = component.config.domElements.optinButton ? component.config.tick.end : component.config.tick.tick + 1;

        if (component.config.tick.tick < component.config.tick.end) {
          setTimeout(_intervalFunction, component.config.tick.interval);
        } else if (component.config.tick.tick === component.config.tick.end && component.config.domElements.optinButton) {
          callBack();
        } else {
          return false;
        }
      }, component.config.tick.interval);
    };

    var _cookieArray = function _cookieArray() {

      var returnValue = null;

      if (document.cookie) {
        returnValue = document.cookie.split(';');
      }
      return returnValue === null ? [] : returnValue;
    };

    var _cookieCheck = function _cookieCheck() {

      var returnValue = false;

      component.cookieArray().find(function (cookieName) {
        if (cookieName.indexOf(component.config.cookie.name) > -1) {
          returnValue = true;
        }
      });

      component.config.cookie.isSet = returnValue;
      return returnValue;
    };

    var _showComponent = function _showComponent() {
      component.element.style.display = 'block';
    };

    var _bindEventListeners = function _bindEventListeners() {

      if (component.config.domElements.optinButton !== undefined && component.config.domElements.optinButton !== null) {
        component.config.domElements.optinButton.setAttribute('data-show-sticky-cookie', '');
        component.config.domElements.optinButton.addEventListener('click', function (e) {

          component.showComponent();
        });
      }
    };

    component.config = _config;
    component.init = _init;
    component.cookieArray = _cookieArray;
    component.cookieCheck = _cookieCheck;
    component.showComponent = _showComponent;
    component.bindEventListeners = _bindEventListeners;
    component.intervalCheck = _intervalCheck;
    return component;
  };

  return stickyOptanonCookieButton;
});
//# sourceMappingURL=stickyOptanonCookieButton.js.map
